import logoLightAsset from "@/assets/factory-logo-384.webp.asset.json";
import logoBorderedAsset from "@/assets/logo-bordered-cropped.svg";

export function Logo({ className }: { className?: string }) {
  return (
    <span className={`flex items-center ${className ?? ""}`}>
      {/* Bordered logo (lime with contrasting outline) for the light theme */}
      <img
        src={logoBorderedAsset}
        alt="factory.online"
        width={96} height={32}
        className="block h-8 w-auto dark:hidden"
        loading="eager"
        decoding="async"
        fetchPriority="low"
      />
      {/* Lime logo for the dark theme */}
      <img
        src={logoLightAsset.url}
        alt="factory.online"
        width={96} height={32}
        className="hidden h-8 w-auto dark:block"
        loading="eager"
        decoding="sync"
        fetchPriority="high"
      />
    </span>
  );
}
